<template>
  <a-popover
    v-model:visible="isVisible"
    trigger="click"
    :placement="placement"
  >
    <template #content>
      <a-spin :spinning="isLoading">
        <div class="label">
          {{ $tm('statistic.table.remind.label') }}：
        </div>
        <a-radio-group
          v-model:value="remindType"
          :style="{ display: 'block' }"
        >
          <a-radio
            v-for="option in remindTypeOptions"
            :key="option.value"
            :value="option.value"
            class="radio-item"
          >
            {{ option.text }}
          </a-radio>
        </a-radio-group>
        <a-button
          type="primary"
          size="small"
          :disabled="!remindType"
          :style="{ marginTop: '4px' }"
          @click="onSubmit"
        >
          {{ $t('shared.ok') }}
        </a-button>
      </a-spin>
    </template>
    <slot />
  </a-popover>
</template>

<script>
import { defineComponent, ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { message } from 'ant-design-vue'

import { remind } from '@/graphql/remind'

export default defineComponent({
  name: 'Remind',
  components: {},
  props: {
    userIds: {
      type: Array,
      required: true
    },
    placement: {
      type: String,
      required: true
    }
  },
  setup (props) {
    const { state } = useStore()
    const { tm } = useI18n()
    const isVisible = ref(false)
    const remindType = ref()
    const cycleId = computed(() => state.selectedCycleId)
    const isLoading = ref(false)
    const remindTypeOptions = computed(() => [
      {
        text: remindTm('fill'),
        value: 'CREATE'
      },
      {
        text: remindTm('align'),
        value: 'LINK'
      },
      {
        text: remindTm('update'),
        value: 'UPDATE'
      },
      {
        text: remindTm('review'),
        value: 'REVIEW'
      }
    ])

    function onSubmit () {
      isLoading.value = true
      remind(cycleId.value, remindType.value, props.userIds)
        .then(() => {
          message.success(tm('statistic.table.remind.successMessage'))
        })
        .finally(() => {
          isLoading.value = false
          isVisible.value = false
          remindType.value = null
        })
    }

    function remindTm (name) {
      return tm('statistic.table.remind.' + name)
    }

    return {
      isLoading,
      isVisible,
      remindTypeOptions,
      remindType,
      onSubmit
    }
  }
})
</script>

<style lang="less" scoped>
.label {
  margin-bottom: 4px;
}

.radio-item {
  display: block;
  height: 30px;
  line-height: 30px;
}
</style>
